export default __webpack_public_path__ + "static/media/close-small-black.e1b05ee4.svg";